import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PawPrint, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { PetAvatar } from "@/components/PetAvatar";

const MOOD = { gluecklich: "glücklich", hungrig: "hungrig", traurig: "traurig", krank: "krank" };

export function ProfilePet({ p }) {
  const [pet, setPet] = useState(undefined);
  useEffect(() => { api.get(`/users/${p.user_id}/pet`).then(({ data }) => setPet(data.pet)).catch(() => setPet(null)); }, [p.user_id]);
  if (!pet) return null;
  const toggle = async () => {
    try { await api.post("/pet/visibility", { public: !pet.public }); setPet({ ...pet, public: !pet.public }); toast.success(pet.public ? "Haustier ist jetzt nur für dich sichtbar" : "Haustier ist jetzt auf deinem Profil sichtbar"); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const pct = pet.next_xp ? Math.min(100, Math.round((pet.xp / pet.next_xp) * 100)) : 100;
  return (
    <div className="bg-white rounded-3xl border border-pink-100 p-5" data-testid="profile-pet">
      <div className="flex items-center justify-between gap-2 mb-3">
        <h3 className="font-bold text-lg flex items-center gap-2"><PawPrint className="w-4 h-4 text-rose-500" /> {p.is_me ? "Mein Haustier" : "Haustier"}</h3>
        {p.is_me && <button onClick={toggle} data-testid="profile-pet-visibility" className="text-xs font-semibold text-slate-500 inline-flex items-center gap-1 hover:text-rose-600">{pet.public ? <><Eye className="w-3.5 h-3.5" /> Für alle sichtbar</> : <><EyeOff className="w-3.5 h-3.5" /> Nur für dich</>}</button>}
      </div>
      <div className="flex items-center gap-4">
        <PetAvatar kind={pet.kind} name={pet.name} equipped={pet.equipped} testId="profile-pet-image" className={`w-24 h-24 shrink-0 ${pet.mood === "gluecklich" ? "pet-bounce" : ""}`} imgClass={`shadow-lg shadow-rose-100 ${pet.mood === "gluecklich" ? "" : "grayscale-[30%]"}`} />
        <div className="min-w-0 flex-1">
          <p className="font-display text-xl font-extrabold truncate" data-testid="profile-pet-name">{pet.name}</p>
          <p className="text-sm text-slate-500"><span data-testid="profile-pet-stage">{pet.stage}</span> · {MOOD[pet.mood]} · {pet.fed_days}× gefüttert</p>
          <div className="h-2 rounded-full bg-rose-50 overflow-hidden mt-2"><div className="h-full pink-gradient" style={{ width: `${pct}%` }} /></div>
          {p.is_me && <Link to="/haustier" className="text-xs font-bold text-rose-600 mt-2 inline-block" data-testid="profile-pet-open">Zum Haustier →</Link>}
        </div>
      </div>
    </div>
  );
}
